import { MenuItem, SelectChangeEvent, TextField } from "@mui/material";
import { Select } from "@mui/material";
import { Grid, Paper } from "@mui/material";
import React, { Suspense, useContext, useEffect, useMemo } from "react";

import {
	AuthContext,
	DependentsContext,
	EligibleDependentContext,
	EnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../../../contexts";
import { LazyCustomFormDialog, LazyPlanActions } from "../../../../../../shared";
import { Checkbox } from "@mui/material";
import { useState } from "react";
import { useCallback } from "react";

import { CustomSelectInput } from "../../../../../../shared/CustomInput";

import "./wholeLifeInsurance.css";
import { useHistory, useLocation } from "react-router-dom";
import { CustomFormDialogType } from "../../../../../../../types/components/dialogProps.types";

import { VEB_PLAN_NAMES } from "../../../../../../../constants/plan";
import {
	PaycheckFrequency,
	VEBPlan,
	WholeLifeAge,
	WholeLifeChildPlanDetails,
	WholeLifeFaceAmountFrequency,
	WholeLifePlanCoverage,
	WholeLifePlanDetails,
	WholeLifePremiumAmount,
	WholeLifeStandardPremiumAmount,
	WholeLifeChildPremiumAmount
} from "../../../../../../../types/plan.types";
import { VEBPlanFormProps } from "../../../../../../../types/components/enrollmentProps.types";

import { api } from "../../../../../../../utils/api";

import { Member } from "../../../../../../../types/employee.types";

import { WholeLifeInsuranceChildPlanData } from "./wholeLifePlanData";
import WholeLifeInsurancePlanData from "./wholeLifePlanData.json";
import {
	getKemperWholeLifeEligibleDependents,
	getKemperWholeLifeEligibleDependentsV2
} from "../../../../../../../utils/commonFunctions/VEBEnrollment/eligibleDependents";

import { CustomDisclaimerDialogPropsType } from "../../../../../../../types/dialogProps.types";

import { trackPromise } from "react-promise-tracker";

import calculateAge, { getAgeInDays } from "../../../../../../../utils/commonFunctions/age";

import { VEBPlanCodes2024 } from "../../../../../../../constants/VEBPlanCodes/VEBPlanCodes2024";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../../../../../constants/VEBYearlyOpenAndCurrentDate";
import CustomEnrollmentDisclaimerDialog from "../../../../../../shared/dialogs/customEnrollmentDisclaimerDialog/customEnrollmentDisclaimerDialog";
import { Block } from "@mui/icons-material";

const KemperStackWholeLifeInsuaranceForm = ({
	onClose,
	VEBOpenEnrollment,
	getVEBEnrollmentInitData,
	vebBenefits
}: // VEBEnrollments
VEBPlanFormProps | any): JSX.Element => {
	const { member, setMember } = useContext(AuthContext);
	// const { dependents, setDependents } = useContext(DependentsContext);
	const { dependents, setDependents } = useContext(DependentsContext);
	const [spouse, setSpouse] = useState<Member | null>(null);

	const [age, setAge] = useState(0);

	const [isSmoker, setSmoker] = useState("smoker");
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();
	const [VEBWholeLifeOpenEnrollment, setVEBWholeLifeOpenEnrollment] = useState<any>({});
	const [wholeLifeInsurancePlan, setWholeLifePlan] = useState<VEBPlan>({
		_id: "",
		plan_name: "",
		plan_code: "",
		start_date: null,
		end_date: null,
		status: ""
	});

	// console.log("whole life rendering stack");

	const coverageCodeConstant: any = {
		EE: "Employee Only",
		ES: "Employee & Spouse",
		ED: "Employee & Dependents",
		EF: "Employee & Family"
	};
	const [wholeLifePlan, seWholeLifePlan] = useState<WholeLifePlanDetails>(WholeLifeInsurancePlanData);

	const [allDependents, setAllDependents] = useState<any>();

	const { eligiblity, setEligiblity } = useContext(EligibleDependentContext);
	const [wholeLifeChildPlan, seWholeLifeChildPlan] = useState<WholeLifeChildPlanDetails>(
		WholeLifeInsuranceChildPlanData
	);

	const { theme } = useContext(ThemeContext);
	const { paycheck } = useContext(PaycheckContext);
	const location = useLocation();
	const history = useHistory();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const [coverage_for, setCoverageFor] = useState("");
	const [memberFaceAmount, setMemberFaceAmount] = useState<null | number>(null);
	const [spouseFaceAmount, setSpouseFaceAmount] = useState<null | number>(null);
	const [childBenefitPlan, setChildBenefitPlan] = useState<null | number>(null);
	const [hasSelectedRider, setHasSelectedRider] = useState<boolean>(false);
	const [childWholeLifePremiumAmount, setChildWholeLifePremiumAmount] = useState<number>(0);
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		VEBPlanName: "Whole life"
	});
	const [memberWeeklyPremium, setmemberWeeklyPremium] = useState<number>(0);
	const [memberAccidentalDeath, setmemberAccidentalDeath] = useState<number>(0);
	const [hasMemberAccidentalDeath, setHasMemberAccidentalDeath] = useState(true);
	const [hasMemberWaiverPremium, setHasMemberWaiverPremium] = useState(true);
	const [hasSpouseAccidentalDeath, setHasSpouseAccidentalDeath] = useState(true);

	const [hasSpouseWaiverPremium, setHasSpouseWaiverPremium] = useState(true);
	const [memberWaiverPremium, setmemberWaiverPremium] = useState<number>(0);
	const [spouseWeeklyPremium, setspouseWeeklyPremium] = useState<number>(0);
	const [spouseAccidentalDeath, setspouseAccidentalDeath] = useState<number>(0);
	const [spouseWaiverPremium, setspouseWaiverPremium] = useState<number>(0);
	const [totalPremium, setTotalPremium] = useState<number>(0);

	const [showMember, setShowMember] = useState(false);
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const [isActivelyWorking, setIsActivelyWorking] = useState(false);
	const [hasReadTC, setHasReadTC] = useState(false);
	const [emailDisclaimer, setEmailDisclaimer] = useState("");
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const [dependentList, setDependentList] = useState<Member[]>([]);
	const [children, setChildren] = useState<Member[]>([]);

	const [eligibleChildren, setEligibleChildren] = useState<any>();

	const [employeeEnrollment, setEmployeeEnrollment] = useState<any>();
	const [childrenEnrollment, setChildrenEnrollment] = useState<any>();
	const [spouseEnrollment, setSpouseEnrollment] = useState<any>();

	const { groupOwner } = useContext(GroupOwnerContext);

	const getVEBPlanCode = useCallback((VEBOpenEnrollment: any[]) => {
		// // console.log("**********VEBOpenEnrollment********", VEBOpenEnrollment[0]);
		let _planCode, _VEBOpenEnrollmentId;
		for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
			const planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
			const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
			const VEBPlanId = VEBOpenEnrollment[idx].open_enrollment.veb_plan_id;
			const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;
			// // console.log("<====Plan Name===>", planName);

			if (planName === VEB_PLAN_NAMES.whole_life) {
				_planCode = planCode;
				_VEBOpenEnrollmentId = VEBOpenEnrollmentId;

				const _planPaylaod = {
					_id: VEBPlanId,
					plan_name: planName,
					plan_code: _planCode,
					start_date: null,
					end_date: null,
					status: "ACTIVE"
				};

				setWholeLifePlan(Object.assign({}, _planPaylaod));

				setVEBWholeLifeOpenEnrollment(Object.assign({}, VEBOpenEnrollment[idx]));
			}
		}

		setPlanCode(_planCode);
		setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
	}, []);

	//End BV2 State

	const handleAgreedTCCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setHasReadTC(checked);
	};

	const handleCoverageChange = (value: any) => {
		// const { value } = event.target;
		setCoverageFor(value);
		if (value === "Employee Only") {
			setShowMember(true);
			setspouseAccidentalDeath(0);
			setspouseWaiverPremium(0);
			setspouseWeeklyPremium(0);
			setSpouseFaceAmount(null);
		} else if (value === "Employee & Spouse") {
			setShowMember(false);
			if (spouseEnrollment && spouseEnrollment.length > 0) {
				setDependentList(spouseEnrollment[0].member);
			}
		} else if (value === "Employee & Dependents") {
			setShowMember(false);

			if (childrenEnrollment && childrenEnrollment.length > 0) {
				setDependentList(childrenEnrollment);
			}
		} else if (value === "Employee & Family") {
			setShowMember(false);
			const dependent: any = [];
			if (spouseEnrollment && spouseEnrollment.length > 0) {
				dependent.push(spouseEnrollment[0].member);
			}
			if (childrenEnrollment && childrenEnrollment.length > 0) {
				childrenEnrollment.forEach((element: any) => {
					dependent.push(element.member);
				});
			}

			setDependentList(dependent);
		} else {
		}
	};

	const handleChildrenBenefitAmount = (event: SelectChangeEvent) => {
		const { value } = event.target;
		if (value === "") {
			setChildBenefitPlan(null);
			setHasSelectedRider(false);
		} else {
			setChildBenefitPlan(parseInt(value));
			setHasSelectedRider(true);
		}
	};

	const handleChronicIllnessChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, checked } = event.target;
		if (name === "member-death-chronic-illness") {
			setHasMemberAccidentalDeath(checked);
		} else {
			setHasSpouseAccidentalDeath(checked);
		}
	}, []);

	const handleWaiverPremiumChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, checked } = event.target;
		if (name === "member-waiver-premium") {
			setHasMemberWaiverPremium(checked);
		} else {
			setHasSpouseWaiverPremium(checked);
		}
	}, []);

	const handlePlanChange = (event: SelectChangeEvent) => {
		const { name, value } = event.target;
		// console.log(name, value);
		// return;
		if (name === "member_face_amount") {
			if (value === "" || value == null || value == undefined || !value) {
				setMemberFaceAmount(null);
			} else {
				setMemberFaceAmount(parseInt(value));
			}
		} else if (name === "spouse_face_amount") {
			if (value === "" || value == null || value == undefined || !value) {
				setSpouseFaceAmount(null);
			} else {
				setSpouseFaceAmount(parseInt(value));
			}
		} else {
			setSpouseFaceAmount(parseInt(value));
		}
	};

	const [enrollmentDisclaimerDialogProps, setEnrollmentDisclaimerDialogProps] =
		useState<CustomDisclaimerDialogPropsType>({
			openDialog: false,
			title: "Disclaimer",
			content:
				"Whole Life : I hereby apply to Reserve National Insurance Company for a life insurance certificate to be issued solely and entirely in reliance upon the written answers to the foregoing questions and/or information obtained by the Company in its underwriting process. I agree and understand that no certificate will be in force until the effective date specified by the Company. I have read or had read to me all the questions and answers in this application and such answers to the best of my (our) knowledge and belief are true and complete. I understand and agree that any falsity of any answer or statement in this application which materially affects the acceptance of the risk or hazard assumed by the Company may bar the right to recovery under any certificate issued. FRAUD STATEMENT: Any person who knowingly presents a false or fraudulent claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in State prison.",

			inputFields: [
				{
					name: "Email Discalimer",
					value: emailDisclaimer,
					placeholder: "Enter Email"
				}
			],
			actions: [
				{
					label: "Email Disclaimer",
					callback: () => {
						null;
						// setEnrollmentDisclaimerDialogProps(
						// 	Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
						// );
					}
				}
			]
		});

	const handleIsActivelyWorkingCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIsActivelyWorking(checked);
	};

	const handleCloseDisclaimerDialog = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleEscapeCloseDisclaimerDialog = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			const Key = event.key;

			if (Key === "Escape")
				setEnrollmentDisclaimerDialogProps(
					Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
				);
		},
		[enrollmentDisclaimerDialogProps]
	);

	const handleValidation = useCallback((): boolean => {
		if (coverage_for === null) {
			// console.log(memberFaceAmount, spouseFaceAmount, childBenefitPlan, childWholeLifePremiumAmount);
			alert("Please fill all required fields");
			return false;
		}

		if (
			(memberFaceAmount == null || memberFaceAmount == 0) &&
			(spouseFaceAmount == null || spouseFaceAmount == 0) &&
			(childBenefitPlan == null || childBenefitPlan == 0) &&
			(childWholeLifePremiumAmount == null || childWholeLifePremiumAmount == 0)
		) {
			return true;
		}
		if (hasReadTC === false) {
			alert("Please agree to the Disclaimer");
			return false;
		}
		if (isActivelyWorking === false) {
			alert("You must actively working 20 hours or more to enroll");
			return false;
		}
		return true;
	}, [
		coverage_for,
		memberFaceAmount,
		spouseFaceAmount,
		childBenefitPlan,
		hasReadTC,
		isActivelyWorking,
		childWholeLifePremiumAmount
	]);

	const handleActivateButtonClick = useCallback(async () => {
		try {
			const isValid = handleValidation();

			if (isValid === false || member === null) {
				return;
			}

			if (member && coverage_for && VEBOpenEnrollment && paycheck) {
				const stack_enrollment: any = {}; // Initialize main object

				const veb_open_enrollment: any = VEBOpenEnrollment?.filter(
					(veb_open_enrollment: any) =>
						veb_open_enrollment.open_enrollment.veb_plan_name == VEB_PLAN_NAMES.whole_life
				);
				// // console.log("veb_open_enrollment", veb_open_enrollment);
				const coverage_code =
					spouseFaceAmount && spouseFaceAmount > 0 && childBenefitPlan && childBenefitPlan > 0
						? "EF"
						: spouseFaceAmount && spouseFaceAmount > 0 && !childBenefitPlan
						? "ES"
						: childBenefitPlan && childBenefitPlan > 0 && !spouseFaceAmount
						? "ECH"
						: "EE";

				// **Member Enrollment (Only if memberFaceAmount is valid)**
				if (memberFaceAmount && Number(memberFaceAmount) > 0) {
					stack_enrollment["employee"] = {
						_id: employeeEnrollment[0]._id,
						increased_benefit_amount: memberFaceAmount,
						top_up_standard_premium: Number(memberWeeklyPremium.toFixed(2)),
						top_up_total_premium: Number(totalPremium.toFixed(2)),
						veb_open_enrollment_id: veb_open_enrollment[0]?.VEB_open_enrollment_id
					};

					// **Accidental Death Rider (Only if valid)**
					if (hasMemberAccidentalDeath && memberAccidentalDeath > 0) {
						stack_enrollment["employee"]["accidental_death_chronic_illness_premium"] =
							memberAccidentalDeath;
					}

					// **Waiver Premium Rider (Only if valid)**
					if (hasMemberWaiverPremium && memberWaiverPremium > 0) {
						stack_enrollment["employee"]["member_waiver_premium"] = memberWaiverPremium;
					}
				}

				// **Spouse Enrollment (Only if spouseFaceAmount is valid)**
				if (
					coverage_for === "Employee & Spouse" ||
					(coverage_for === "Employee & Family" && spouseFaceAmount && spouseFaceAmount > 0)
				) {
					stack_enrollment["spouse"] = {
						_id: spouseEnrollment[0]._id,
						increased_benefit_amount: spouseFaceAmount,
						top_up_standard_premium: Number(spouseWeeklyPremium.toFixed(2)),
						top_up_total_premium: Number(totalPremium.toFixed(2)),
						veb_open_enrollment_id: veb_open_enrollment[0]?.VEB_open_enrollment_id
					};

					// **Spouse Accidental Death Rider (Only if valid)**
					if (hasSpouseAccidentalDeath && spouseAccidentalDeath > 0) {
						stack_enrollment["spouse"]["accidental_death_chronic_illness_premium"] = spouseAccidentalDeath;
					}

					// **Spouse Waiver Premium Rider (Only if valid)**
					if (hasSpouseWaiverPremium && spouseFaceAmount) {
						stack_enrollment["spouse"]["member_waiver_premium"] = memberWaiverPremium;
					}
				}

				// **Children Enrollment (Only if childBenefitPlan is valid)**
				if (childBenefitPlan && childBenefitPlan > 0) {
					const children = childrenEnrollment.map((child: any) => ({
						_id: child._id,
						increased_benefit_amount: childBenefitPlan,
						top_up_standard_premium: Number(childWholeLifePremiumAmount.toFixed(2)),
						top_up_total_premium: Number(childWholeLifePremiumAmount.toFixed(2)),
						veb_open_enrollment_id: veb_open_enrollment[0]?.VEB_open_enrollment_id
					}));

					if (children.length > 0) {
						stack_enrollment["children"] = children;
					}
				}

				// **Common Details (Always Added)**
				stack_enrollment["common_details"] = {
					plan: wholeLifeInsurancePlan,
					coverage_code: coverage_code,
					veb_plan_name: "Whole life",
					effective_date: VEBPlanCodes2024.includes(wholeLifeInsurancePlan.plan_code as unknown as string)
						? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
						: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD,
					veb_plan_code: veb_open_enrollment[0]?.open_enrollment.veb_plan_code,
					veb_open_enrollment_id: veb_open_enrollment[0]?.VEB_open_enrollment_id,
					open_enrollment_for: veb_open_enrollment[0].open_enrollment.open_enrollment_for,
					employee_SSN: veb_open_enrollment[0]?.employee_SSN,
					is_rider: hasSelectedRider ? true : false
				};

				// // console.log("VEBStackEnrollments", stack_enrollment);

				const standardResponse = await trackPromise(api.enrollment.stackWholeLifeEnrollment(stack_enrollment));
				if (standardResponse) {
					getVEBEnrollmentInitData();
					if (
						(memberFaceAmount == null || memberFaceAmount == 0) &&
						(spouseFaceAmount == null || spouseFaceAmount == 0) &&
						(childBenefitPlan == null || childBenefitPlan == 0) &&
						(childWholeLifePremiumAmount == null || childWholeLifePremiumAmount == 0)
					) {
						const step = urlSearchParams.get("step");
						history.push(`?step=${step}&stage=0`);
						onClose();
					} else {
						const step = urlSearchParams.get("step");
						history.push(`?step=${step}&stage=2`);
						onClose();
					}
				}
			}
		} catch (Err: any) {
			// console.log(Err);
		}
	}, [
		handleValidation,
		member,
		coverage_for,
		VEBOpenEnrollment,
		paycheck,
		spouseFaceAmount,
		childBenefitPlan,
		memberFaceAmount,
		wholeLifeInsurancePlan,
		hasSelectedRider,
		employeeEnrollment,
		memberWeeklyPremium,
		totalPremium,
		hasMemberAccidentalDeath,
		memberAccidentalDeath,
		hasMemberWaiverPremium,
		memberWaiverPremium,
		spouseEnrollment,
		spouseWeeklyPremium,
		hasSpouseAccidentalDeath,
		spouseAccidentalDeath,
		hasSpouseWaiverPremium,
		childrenEnrollment,
		childWholeLifePremiumAmount,
		getVEBEnrollmentInitData,
		urlSearchParams,
		history
	]);

	const handleOpenDisclaimerDialogClick = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: true }));
	}, [enrollmentDisclaimerDialogProps]);

	const calculateAgeFromDOB = (date_of_birth: string | number | Date) => {
		const dob = new Date(date_of_birth);
		const ageDifMs =
			new Date(VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD).getTime() -
			dob.getTime();
		const ageDate = new Date(ageDifMs);
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	};

	//paycheck", paycheck);
	// console.log(coverage_for);

	useEffect(() => {
		if (spouseEnrollment && spouseEnrollment.length > 0) {
			setSpouse(spouseEnrollment[0].member);
		}
	}, [spouseEnrollment]);

	useEffect(() => {
		if (member) {
			let premiumAmount = 0;
			let deathChronicIllness = 0;
			let waiverOfPremium = 0;
			let spousePrimiumAmount = 0;
			let spouseDeathChronicIllness = 0;
			let spouseWaiverOfPremium = 0;

			if (spouseEnrollment && spouseEnrollment.length > 0) {
				setSpouse(spouseEnrollment[0].member);
			}
			const { is_tobacco, date_of_birth } = member;
			const tobacco = is_tobacco === true ? "smoker" : "non_smoker";
			setSmoker(tobacco);
			const dob = typeof date_of_birth === "string" ? new Date(date_of_birth) : new Date();
			const ageDifMs =
				new Date(VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD).getTime() -
				dob.getTime();
			const ageDate = new Date(ageDifMs);
			const calculate_age = Math.abs(ageDate.getUTCFullYear() - 1970);
			setAge(calculate_age);
			//const calculate_age = 18;
			//setAge(18);
			const ECHRelationship = ["SON", "CHILD", "DAUGHTER", "STEP CHILD"];
			if (allDependents && allDependents.length > 0) {
				const children = allDependents.filter((child: any) => {
					const relationship = child.relationship !== null ? child.relationship : "";
					if (ECHRelationship.includes(relationship)) {
						const childDOB: Date =
							child.date_of_birth === undefined ? new Date() : new Date(child.date_of_birth);
						const age = calculateAgeFromDOB(childDOB);
						if (getAgeInDays(child.date_of_birth) >= 30 && age < 26) {
							return child;
						}
					}
				});
				setChildren(children);
			}
			if (paycheck && coverage_for !== "") {
				//calculate_age.toString()", calculate_age.toString());

				if (memberFaceAmount != null) {
					// // console.log(
					// 	"wholeLifePlan.premium_amount [tobacco as keyof WholeLifePremiumAmount]",
					// 	wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount]
					// );
					// // console.log(
					// 	"wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][calculate_age.toString() as keyof WholeLifeAge]",
					// 	wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][
					// 		calculate_age.toString() as keyof WholeLifeAge
					// 	]
					// );
					premiumAmount =
						wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][
							calculate_age.toString() as keyof WholeLifeAge
						]["standard_premium" as keyof WholeLifeStandardPremiumAmount][
							coverage_for as keyof WholeLifePlanCoverage
						][memberFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
							paycheck.pay_frequency as keyof PaycheckFrequency
						] || 0;
					deathChronicIllness =
						wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][
							calculate_age.toString() as keyof WholeLifeAge
						]["rider_chronicle_illness" as keyof WholeLifeStandardPremiumAmount][
							coverage_for as keyof WholeLifePlanCoverage
						][memberFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
							paycheck.pay_frequency as keyof PaycheckFrequency
						] || 0;
					if (hasMemberWaiverPremium === true) {
						//calculate_age", calculate_age);
						//paycheck.pay_frequency", paycheck.pay_frequency);
						waiverOfPremium =
							wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][
								calculate_age.toString() as keyof WholeLifeAge
							]["rider_waiver_premium" as keyof WholeLifeStandardPremiumAmount][
								coverage_for as keyof WholeLifePlanCoverage
							][memberFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
								paycheck.pay_frequency as keyof PaycheckFrequency
							] || 0;

						//waiverOfPremium", waiverOfPremium);
					}

					setmemberWeeklyPremium(premiumAmount);
					setmemberAccidentalDeath(deathChronicIllness);
					setmemberWaiverPremium(waiverOfPremium);
					// console.log(
					// 	"GG: deathChronicIllness",
					// 	wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][
					// 		calculate_age.toString() as keyof WholeLifeAge
					// 	]["rider_chronicle_illness" as keyof WholeLifeStandardPremiumAmount][
					// 		coverage_for as keyof WholeLifePlanCoverage
					// 	][memberFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
					// 		paycheck.pay_frequency as keyof PaycheckFrequency
					// 	]
					// );
				} else {
					setmemberWeeklyPremium(0);
					setmemberAccidentalDeath(0);
					setmemberWaiverPremium(0);
				}
			}
			if (paycheck && coverage_for !== "") {
				if (spouseFaceAmount != null) {
					if (allDependents.find((val: any) => val.relationship === "SPOUSE")) {
						const dep_is_tobacco = allDependents.find(
							(val: any) => val.relationship === "SPOUSE"
						)?.is_tobacco;
						const dep_date_of_birth = allDependents.find(
							(val: { relationship: string }) => val.relationship === "SPOUSE"
						)?.date_of_birth;
						const tobacco_dep = dep_is_tobacco === true ? "smoker" : "non_smoker";
						const dob_dep = dep_date_of_birth === undefined ? new Date() : new Date(dep_date_of_birth);
						const ageDifMs_dep = Date.now() - dob_dep.getTime();
						const ageDate_dep = new Date(ageDifMs_dep);
						const calculate_age_dep = Math.abs(ageDate_dep.getUTCFullYear() - 1970);
						//const calculate_age_dep = 18;
						spousePrimiumAmount =
							wholeLifePlan.premium_amount[tobacco_dep as keyof WholeLifePremiumAmount][
								calculate_age_dep.toString() as keyof WholeLifeAge
							]["standard_premium" as keyof WholeLifeStandardPremiumAmount][
								coverage_for as keyof WholeLifePlanCoverage
							][spouseFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
								paycheck.pay_frequency as keyof PaycheckFrequency
							] || 0;
						spouseDeathChronicIllness =
							wholeLifePlan.premium_amount[tobacco_dep as keyof WholeLifePremiumAmount][
								calculate_age_dep.toString() as keyof WholeLifeAge
							]["rider_chronicle_illness" as keyof WholeLifeStandardPremiumAmount][
								coverage_for as keyof WholeLifePlanCoverage
							][spouseFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
								paycheck.pay_frequency as keyof PaycheckFrequency
							] || 0;
						if (hasSpouseWaiverPremium) {
							spouseWaiverOfPremium =
								wholeLifePlan.premium_amount[tobacco_dep as keyof WholeLifePremiumAmount][
									calculate_age_dep.toString() as keyof WholeLifeAge
								]["rider_waiver_premium" as keyof WholeLifeStandardPremiumAmount][
									coverage_for as keyof WholeLifePlanCoverage
								][spouseFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
									paycheck.pay_frequency as keyof PaycheckFrequency
								] || 0;
						}

						setspouseWeeklyPremium(spousePrimiumAmount === undefined ? 0 : spousePrimiumAmount);
						setspouseAccidentalDeath(
							spouseDeathChronicIllness === undefined ? 0 : spouseDeathChronicIllness
						);
						setspouseWaiverPremium(spouseWaiverOfPremium === undefined ? 0 : spouseWaiverOfPremium);
					}
				} else {
					setspouseWeeklyPremium(0);
					setspouseAccidentalDeath(0);
					setspouseWaiverPremium(0);
				}
			}
			const children_benefit_amount =
				childBenefitPlan && childBenefitPlan > 0
					? wholeLifeChildPlan.premium_amount[
							childBenefitPlan?.toString() as keyof WholeLifeChildPremiumAmount
					  ][paycheck?.pay_frequency as keyof PaycheckFrequency]
					: 0;
			setChildWholeLifePremiumAmount(children_benefit_amount ? children_benefit_amount : 0);

			const total_premium =
				premiumAmount +
				childWholeLifePremiumAmount +
				(hasMemberAccidentalDeath === true ? deathChronicIllness : 0) +
				(hasMemberWaiverPremium ? waiverOfPremium : 0) +
				spousePrimiumAmount +
				(hasSpouseAccidentalDeath === true ? spouseDeathChronicIllness : 0) +
				(hasSpouseWaiverPremium === true ? spouseWaiverOfPremium : 0);
			setTotalPremium(Number(total_premium.toFixed(2)));
			setCurrentEnrollment(
				Object.assign(
					{},
					{
						plan_name: "Whole life",
						status: "Current",
						premium_amount: Number(total_premium.toFixed(2))
					}
				)
			);
		}
	}, [
		age,
		dependentList,
		coverage_for,
		allDependents,
		hasMemberAccidentalDeath,
		hasMemberWaiverPremium,
		hasSpouseAccidentalDeath,
		hasSpouseWaiverPremium,
		member,
		memberFaceAmount,
		paycheck,
		spouseFaceAmount,
		wholeLifePlan.premium_amount,
		childBenefitPlan,
		childWholeLifePremiumAmount,
		wholeLifeChildPlan.premium_amount,
		setCurrentEnrollment,
		spouseEnrollment
	]);

	useEffect(() => {
		if (VEBOpenEnrollment && VEBOpenEnrollment.length !== 0) {
			getVEBPlanCode(VEBOpenEnrollment);
		}
	}, [VEBOpenEnrollment, getVEBPlanCode]);

	useEffect(() => {
		if (allDependents && allDependents.length > 0) {
			const dependentCoverage = getKemperWholeLifeEligibleDependents(allDependents);
			seWholeLifePlan((prevWholeLifePlanDetails: WholeLifePlanDetails) => {
				return Object.assign({}, prevWholeLifePlanDetails, {
					coverage: dependentCoverage.coverage
				});
			});
		}
	}, [allDependents]);

	useEffect(() => {
		if (allDependents) {
			const dependentCoverage = getKemperWholeLifeEligibleDependentsV2(allDependents);

			const spouse = dependentCoverage.dependents.find(
				(dependent: Member) => dependent.relationship === "SPOUSE"
			);
			if (spouse) {
				const spouseAge = calculateAge(
					spouse.date_of_birth,
					VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
				);
				if (spouseAge > 60) {
					setHasSpouseWaiverPremium(false);
				}
			}
			if (member) {
				const memberAge = calculateAge(
					member.date_of_birth,
					VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
				);
				if (memberAge > 60) {
					setHasMemberWaiverPremium(false);
				}
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [allDependents, setEligiblity, member]);

	const getBenefits = useCallback(async () => {
		const coverage_code = vebBenefits.map((benefit: any) => benefit.coverage_code);
		const employeeEnrollment = vebBenefits.filter((benefit: any) => benefit.insured_SSN == benefit.member_SSN);
		const spouseEnrollment = vebBenefits.filter((benefit: any) => benefit["member"].relationship == "SPOUSE");
		const childrenEnrollment = vebBenefits.filter(
			(benefit: any) =>
				benefit["member"].relationship == "CHILD" ||
				benefit["member"].relationship == "STEP CHILD" ||
				benefit["member"].relationship == "GRANDCHILD" ||
				benefit["member"].relationship == "LEGAL CUSTODY CHILD" ||
				benefit["member"].relationship == "COURT-ORDERED DEPENDENT" ||
				benefit["member"].relationship == "DISABLED CHILD"
		);

		const ECHRelationship = ["SON", "CHILD", "DAUGHTER", "STEP CHILD"];

		if (childrenEnrollment && childrenEnrollment.length > 0) {
			const children = childrenEnrollment.filter((child: any) => {
				const relationship = child["member"].relationship !== null ? child["member"].relationship : "";
				if (ECHRelationship.includes(relationship)) {
					const childDOB: Date =
						child["member"].date_of_birth === undefined
							? new Date()
							: new Date(child["member"].date_of_birth);
					const age = calculateAgeFromDOB(childDOB);
					if (getAgeInDays(child["member"].date_of_birth) >= 30 && age < 26) {
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			});
			// console.log("children", children);

			setEligibleChildren(children);
		}

		setEmployeeEnrollment(employeeEnrollment);

		const dependentsList = [];
		if (spouseEnrollment && spouseEnrollment.length > 0) {
			dependentsList.push(spouseEnrollment[0].member);
		}
		if (childrenEnrollment && childrenEnrollment.length > 0) {
			childrenEnrollment.forEach((element: any) => {
				dependentsList.push(element.member);
			});
		}

		setAllDependents(dependentsList);

		setChildrenEnrollment(childrenEnrollment);

		setSpouseEnrollment(spouseEnrollment);
		handleCoverageChange(coverageCodeConstant[coverage_code[0]]);
		//vebBenfits", vebBenefits);
		if (vebBenefits) {
		}
	}, [vebBenefits]);

	useEffect(() => {
		getBenefits();
	}, [getBenefits, member]);

	return (
		<Suspense fallback={<div />}>
			<Suspense fallback={<div />}>
				<CustomEnrollmentDisclaimerDialog
					enrollmentDisclaimerDialogProps={enrollmentDisclaimerDialogProps}
					handleCloseDisclaimerDialog={handleCloseDisclaimerDialog}
					handleEscapeCloseDisclaimerDialog={handleEscapeCloseDisclaimerDialog}
					emailDisclaimer={emailDisclaimer}
					setEmailDisclaimer={setEmailDisclaimer}
				/>
			</Suspense>
			<Suspense fallback={<div />}>
				{customFormDialogProps ? <LazyCustomFormDialog customFormDialogProps={customFormDialogProps} /> : null}
			</Suspense>
			<div className="kemper-cancer-form plan-form">
				<div className="paper-form-container" style={{ padding: "0" }}>
					<Paper className="theme-border-radius paper-container" elevation={1}>
						<div className="plan-content">
							{/* <div className="theme-plan-section-margin" /> */}
							<div className="header-container header-container-new" style={{ marginTop: "-30px" }}>
								<div className="theme-plan-header">
									Stack Benefits({member.first_name} {member.last_name})
								</div>
							</div>
							<div>
								<div
									className="theme-plan-sub-header plan-text"
									style={{ borderLeftColor: theme.primary_color }}
								>
									In addition to yourself, who would you like to cover under this plan?
								</div>
								<Grid className="grid-container" container columnSpacing={2}>
									<Grid container columnSpacing={2}>
										<Grid item xl={3} lg={3} md={3} sm={3} xs={4}>
											<div className="details-form-row">
												<div className="details-form-label">Current Benefit Amount</div>

												{employeeEnrollment && employeeEnrollment.length > 0 && (
													<TextField
														className="current-benefit-amounts"
														value={employeeEnrollment[0].benefit_amount}
														// InputProps={{
														// 	startAdornment: <Block />, // <== adjusted this
														// 	disableUnderline: true // <== added this
														// }}
														disabled
													>
														{employeeEnrollment[0].benefit_amount}
													</TextField>
												)}
											</div>
										</Grid>
										{employeeEnrollment && employeeEnrollment.length > 0 && (
											<Grid item xl={3} lg={3} md={3} sm={3} xs={4}>
												<div className="details-form-row">
													<div className="details-form-label  required">Top Up Amount</div>
													<Select
														input={<CustomSelectInput />}
														style={{ width: "100%" }}
														name="member_face_amount"
														onChange={(event: SelectChangeEvent) => handlePlanChange(event)}
													>
														<MenuItem value={""}>No Select</MenuItem>
														{wholeLifePlan.coverage_level
															.filter(
																(item, index) =>
																	item &&
																	item <=
																		Number(
																			100000 -
																				employeeEnrollment[0].benefit_amount
																		) &&
																	item <= 100000
															)
															.map((coverage, index) => {
																return (
																	// eslint-disable-next-line react/jsx-key
																	<MenuItem value={coverage === null ? "" : coverage}>
																		{coverage === null ? "Select" : coverage}
																	</MenuItem>
																);
															})}
													</Select>
												</div>
											</Grid>
										)}
										<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
											<div className="details-form-row">
												<div className="details-form-label required align-center">
													Top Up Premium
												</div>
												<div className="show-premium">
													<div className="show-premium">
														{memberWeeklyPremium == 0
															? "$0.00"
															: `$${
																	memberWeeklyPremium &&
																	memberWeeklyPremium.toFixed(2)
															  }`}
													</div>
												</div>
											</div>
										</Grid>
										{employeeEnrollment && employeeEnrollment.length > 0 && (
											<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
												<div className="details-form-row">
													<div className="details-form-label required align-center">
														Current Premium
													</div>
													<div className="show-premium">
														<div className="show-premium">
															${employeeEnrollment[0].premium_amount.toFixed(2)}
														</div>
													</div>
												</div>
											</Grid>
										)}
									</Grid>
									<Grid container columnSpacing={2}>
										<Grid item xl={3} lg={3} md={3} sm={3} xs={4}>
											<div style={{ display: "flex" }} className="margin-top-10">
												<Checkbox
													checked={hasMemberAccidentalDeath}
													style={{ paddingLeft: 0 }}
													onChange={handleChronicIllnessChange}
													name="member-death-chronic-illness"
													className="margin-fix"
													disabled={true}
												/>
												<div className="checkbox-label details-form-row">
													<div className="details-form-label">
														Accidental Death Chronic illness
													</div>
												</div>
											</div>
										</Grid>
										<Grid item xl={3} lg={3} md={3} sm={3} xs={4}></Grid>
										<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
											<div className="details-form-row">
												{hasMemberAccidentalDeath && (
													<div className="show-premium">
														{memberAccidentalDeath == 0
															? "$0.00"
															: `$${
																	memberAccidentalDeath &&
																	memberAccidentalDeath.toFixed(2)
															  }`}
													</div>
												)}
											</div>
										</Grid>
									</Grid>
									<Grid container columnSpacing={2}>
										<Grid item xl={3} lg={3} md={3} sm={3} xs={4}>
											<div style={{ display: "flex" }}>
												<Checkbox
													checked={hasMemberWaiverPremium}
													style={{ paddingLeft: 0 }}
													onChange={handleWaiverPremiumChange}
													name="member-waiver-premium"
													className="margin-fix"
													disabled={true}
												/>
												<div className="checkbox-label details-form-row">
													<div className="details-form-label">Wavier Of Premium</div>
												</div>
											</div>
										</Grid>
										<Grid item xl={3} lg={3} md={3} sm={3} xs={4}></Grid>
										<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
											<div className="details-form-row margin-top-minus-8">
												{hasMemberWaiverPremium && (
													<div className="show-premium">
														{memberWaiverPremium == 0
															? "$0.00"
															: `$${
																	memberWaiverPremium &&
																	memberWaiverPremium.toFixed(2)
															  }`}
													</div>
												)}
											</div>
										</Grid>
									</Grid>
								</Grid>
							</div>
						</div>
						{/* Spouse */}
						{spouseEnrollment &&
							employeeEnrollment &&
							employeeEnrollment.length > 0 &&
							spouseEnrollment.length > 0 &&
							spouseEnrollment.map((spouse: any, index: number) => {
								return (
									<div key={index}>
										<div
											className={
												coverage_for === "Employee Only" || coverage_for === ""
													? "hidden"
													: "header-container header-container-new margin-top-20"
											}
										>
											<div className="theme-plan-header">
												{spouse["member"]?.relationship}({spouse["member"]?.first_name}{" "}
												{spouse["member"]?.last_name})
											</div>
										</div>
										<Grid
											className={
												coverage_for === "Employee Only" || coverage_for === ""
													? "hidden"
													: "grid-container member-grid"
											}
											container
											columnSpacing={2}
										>
											<Grid container columnSpacing={2}>
												<Grid item xl={3} lg={3} md={3} sm={3} xs={4}>
													<div className="details-form-row">
														<div className="details-form-label">Current Benefit Amount</div>

														<TextField value={spouseEnrollment[0].benefit_amount} disabled>
															{spouseEnrollment[0].benefit_amount}
														</TextField>
													</div>
												</Grid>
												<Grid item xl={3} lg={3} md={3} sm={3} xs={4}>
													<div className="details-form-row">
														<div className="details-form-label  required">
															Top Up Amount
														</div>
														<Select
															input={<CustomSelectInput />}
															style={{ width: "100%" }}
															name="spouse_face_amount"
															onChange={(event: SelectChangeEvent) =>
																handlePlanChange(event)
															}
														>
															<MenuItem value="">No Select</MenuItem>
															{spouse["member"]?.relationship.toLocaleUpperCase() ===
																"SPOUSE" &&
																wholeLifePlan.coverage_level
																	.filter(
																		(item, index) =>
																			item &&
																			item <=
																				Number(
																					50000 -
																						spouseEnrollment[0]
																							.benefit_amount
																				) &&
																			item <=
																				Number(
																					employeeEnrollment[0]
																						.benefit_amount +
																						Number(
																							memberFaceAmount
																								? memberFaceAmount
																								: 0
																						) -
																						spouseEnrollment[0]
																							.benefit_amount
																				)
																	)
																	.map((coverage, index) => {
																		return (
																			// eslint-disable-next-line react/jsx-key
																			<MenuItem
																				value={
																					coverage === null
																						? ""
																						: coverage.toString()
																				}
																			>
																				{coverage === null
																					? "Select"
																					: coverage}
																			</MenuItem>
																		);
																	})}
														</Select>
													</div>
												</Grid>

												<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
													<div className="details-form-row">
														<div className="details-form-label required align-center">
															Top Up Premium
														</div>
														<div className="show-premium">
															<div className="show-premium">
																{spouseWeeklyPremium == 0
																	? "$0.00"
																	: `$${
																			spouseWeeklyPremium &&
																			spouseWeeklyPremium.toFixed(2)
																	  }`}
															</div>
														</div>
													</div>
												</Grid>
												{spouseEnrollment && spouseEnrollment.length > 0 && (
													<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
														<div className="details-form-row">
															<div className="details-form-label required align-center">
																Current Premium
															</div>
															<div className="show-premium">
																<div className="show-premium">
																	${spouseEnrollment[0].premium_amount.toFixed(2)}
																</div>
															</div>
														</div>
													</Grid>
												)}
											</Grid>
											<Grid container columnSpacing={2}>
												<Grid item xl={3} lg={3} md={3} sm={3} xs={4}>
													<div style={{ display: "flex" }} className="margin-top-10">
														<Checkbox
															checked={hasSpouseAccidentalDeath}
															style={{ paddingLeft: 0 }}
															onChange={handleChronicIllnessChange}
															name="spouse-death-chronic-illness"
															className="margin-fix"
															disabled={true}
														/>
														<div className="checkbox-label details-form-row">
															<div className="details-form-label">
																Accidental Death Chronic illness
															</div>
														</div>
													</div>
												</Grid>
												<Grid item xl={3} lg={3} md={3} sm={3} xs={4}></Grid>
												<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
													<div className="details-form-row">
														{hasSpouseAccidentalDeath && (
															<div className="show-premium">
																{spouseAccidentalDeath == 0
																	? "$0.00"
																	: `$${
																			hasSpouseAccidentalDeath &&
																			spouseAccidentalDeath.toFixed(2)
																	  }`}
															</div>
														)}
													</div>
												</Grid>
											</Grid>
											<Grid container columnSpacing={2}>
												<Grid item xl={3} lg={3} md={3} sm={3} xs={4}>
													<div style={{ display: "flex" }}>
														<Checkbox
															checked={hasSpouseWaiverPremium}
															style={{ paddingLeft: 0 }}
															onChange={handleWaiverPremiumChange}
															name="spouse-waiver-premium"
															className="margin-fix"
															disabled={true}
														/>
														<div className="checkbox-label details-form-row">
															<div className="details-form-label">Wavier Of Premium</div>
														</div>
													</div>
												</Grid>
												<Grid item xl={3} lg={3} md={3} sm={3} xs={4}></Grid>
												<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
													<div className="details-form-row margin-top-minus-8">
														{hasSpouseWaiverPremium && (
															<div className="show-premium">
																{spouseWaiverPremium == 0
																	? "$0.00"
																	: `$${
																			spouseWaiverPremium &&
																			spouseWaiverPremium.toFixed(2)
																	  }`}
															</div>
														)}
													</div>
												</Grid>
											</Grid>
										</Grid>
									</div>
								);
							})}

						{/* End Spouse */}

						{/* Child */}
						{eligibleChildren && eligibleChildren.length > 0 ? (
							<div className="">
								<div className="header-container-new margin-top-20">
									<div className="theme-plan-header">
										Child Term Life Insurance{" "}
										{eligibleChildren && eligibleChildren.length > 0 ? "(" : null}
										{eligibleChildren.map((child: any, index: number) => {
											return (
												<span key={index}>
													{child["member"]?.first_name} {child["member"]?.last_name}
													{index + 1 === eligibleChildren.length ? "" : ", "}
												</span>
											);
										})}
										{eligibleChildren && eligibleChildren.length > 0 ? ")" : null}
									</div>
								</div>
								<Grid className="grid-container" container columnSpacing={2}>
									<Grid container columnSpacing={2}>
										<Grid item xl={3} lg={3} md={3} sm={3} xs={4}>
											<div className="details-form-row">
												<div className="details-form-label">Current Benefit Amount</div>

												<TextField value={eligibleChildren[0].benefit_amount} disabled>
													{eligibleChildren[0].benefit_amount}
												</TextField>
											</div>
										</Grid>
										<Grid item xl={3} lg={3} md={3} sm={3} xs={4}>
											<div className="details-form-row">
												<div className="details-form-label">Top Up Amount</div>
												<Select
													input={<CustomSelectInput />}
													style={{ width: "100%" }}
													name="children_benefit_plan"
													onChange={(event: SelectChangeEvent) =>
														handleChildrenBenefitAmount(event)
													}
												>
													<MenuItem value="">No Select</MenuItem>
													{wholeLifeChildPlan.coverage_level
														.filter(
															(item, index) =>
																item &&
																item <= 50000 &&
																item <=
																	Number(50000 - eligibleChildren[0].benefit_amount)
														)
														.map((option: any, index: number) => {
															return (
																<MenuItem value={option ? option : ""} key={index}>
																	{option ? option : "Select"}
																</MenuItem>
															);
														})}
												</Select>
											</div>
										</Grid>

										<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
											<div className="details-form-row">
												<div className="details-form-label required align-center">
													Top Up Premium
												</div>
												<div className="show-premium">
													<div className="show-premium">
														{childWholeLifePremiumAmount == 0
															? "$0.00"
															: `$${
																	childWholeLifePremiumAmount &&
																	childWholeLifePremiumAmount.toFixed(2)
															  }`}
													</div>
												</div>
											</div>
										</Grid>
										{eligibleChildren && eligibleChildren.length > 0 && (
											<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
												<div className="details-form-row">
													<div className="details-form-label required align-center">
														Current Premium
													</div>
													<div className="show-premium">
														<div className="show-premium">
															${eligibleChildren[0].premium_amount.toFixed(2)}
														</div>
													</div>
												</div>
											</Grid>
										)}
									</Grid>
								</Grid>
							</div>
						) : (
							<></>
						)}

						{/* End Child */}
						<div className="theme-plan-inner-section-margin-2" />
						<Grid
							container
							className="theme-plan-inner-section-margin"
							style={{ justifyContent: "flex-end", gap: "30px" }}
						>
							{/* <Grid item xl={6.6} lg={6.6} md={6.6} sm={6.6} xs={8}> */}
							<div className="details-form-row">
								<div
									className="details-form-label theme-plan-total-premium align-right"
									style={{ color: theme.primary_color, fontSize: "1em !important" }}
								>
									Total Top Up Premium:{" "}
									<span
										className="show-premium margin-adjust"
										// style={{ fontSize: "1em !important" }}
									>
										{totalPremium == 0 ? "$0.00" : `$${totalPremium && totalPremium.toFixed(2)}`}
									</span>
								</div>
							</div>
							{/* </Grid> */}
							{employeeEnrollment && employeeEnrollment.length > 0 && (
								// <Grid container className="theme-plan-inner-section-margin">
								// <Grid>
								<div className="details-form-row">
									<div
										className="details-form-label theme-plan-total-premium align-right"
										style={{ color: theme.primary_color }}
									>
										Current Total Premium:{" "}
										<span
											className="show-premium margin-adjust"
											// style={{ fontSize: "12px !important" }}
										>
											${employeeEnrollment[0].total_premium.toFixed(2)}
										</span>
									</div>
								</div>
								// </Grid>
								// </Grid>
							)}
						</Grid>

						{employeeEnrollment && employeeEnrollment.length > 0 && (
							<Grid
								container
								className="theme-plan-inner-section-margin"
								style={{ justifyContent: "flex-end" }}
							>
								{/* <Grid item xl={12} lg={12} md={12} sm={12} xs={12}> */}
								{/* <Grid item xl={11.7} lg={11.7} md={11.7} sm={11.7} xs={8}> */}
								<div className="details-form-row">
									<div
										className="details-form-label theme-plan-total-premium align-right"
										style={{ color: theme.primary_color, fontSize: "1em !important" }}
									>
										Total Premium:{" "}
										<span
											className="show-premium margin-adjust"
											// style={{ fontSize: "1em !important" }}
										>
											{totalPremium == 0
												? `$${employeeEnrollment[0].total_premium.toFixed(2)}`
												: `$${(employeeEnrollment[0].total_premium + totalPremium).toFixed(2)}`}
										</span>
									</div>
								</div>
								{/* </Grid> */}
							</Grid>
						)}

						<div className="theme-plan-option-content">
							<Checkbox
								checked={isActivelyWorking}
								style={{ paddingLeft: 0 }}
								onChange={handleIsActivelyWorkingCheckboxChange}
							/>
							<p className="theme-plan-checkbox-label">
								<strong>Are you actively at work 20 or more hours per week?</strong>
							</p>
						</div>
						<div>
							<div className="theme-plan-option-content">
								<Checkbox
									checked={hasReadTC}
									style={{ paddingLeft: 0 }}
									onChange={handleAgreedTCCheckboxChange}
								/>
								<p className="theme-plan-checkbox-label">
									<strong>
										I have read the{" "}
										<span
											className="veb-plan-disclaimer"
											style={{ color: theme.primary_color }}
											onClick={handleOpenDisclaimerDialogClick}
										>
											Disclaimer
										</span>
									</strong>
								</p>
							</div>
						</div>
						<div className="theme-plan-inner-section-margin-2" />
						<LazyPlanActions
							waiveButtonCallback={null}
							activateButtonCallback={handleActivateButtonClick}
						/>
					</Paper>
				</div>
			</div>
		</Suspense>
	);
};

export default KemperStackWholeLifeInsuaranceForm;
